import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const authToken = localStorage.getItem("authToken"); // Retrieve authToken from localStorage

  if (!authToken) {
    return <Navigate to="/login" replace />;
  }

  return children; // If authToken exists, render the children components
};

export default PrivateRoute;
